export default "__VITE_ASSET__DXB0uOMJ__"